<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-comment-dots card-start-icon"></i> {{node.lingualName}} <span v-if="node.data.replyTypeText" class="button_type_text">{{ node.data.replyTypeText }}</span></p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      
      <div ref="displayStatHtml"></div>

      <div class="card-data">
        <div class="text-center mb-1">     
          <div v-if="node.data.replyTypeText">
            <div class="list-group" v-if="'post_back' === node.data.replyType">
              <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.buttonText">
              <span class="list-group-item list-group-item-action flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h6 class="mb-1 card-data-title link-preview">
                    <i class="fas fa-circle text-success"></i> {{ node.data.postbackIdText }}
                  </h6>              
                </div>           
              </span>
            </div>
            <div class="list-group" v-else-if="'new_post_back' === node.data.replyType">
              <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.buttonText">
  
              <div v-if="'new_post_back' === node.data.replyType">
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedLabelTexts(node)">   
                  <small class="text-muted">{{ button_html_add_label }}</small>
                  <p class="mb-0"> {{ getSelectedLabelTexts(node) }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="getSelectedRemoveLabelTexts(node)">   
                  <small class="text-muted">{{ button_html_remove_label }}</small>
                  <p class="mb-0"> {{ getSelectedRemoveLabelTexts(node) }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValue && node.data.sequenceIdText">   
                  <small class="text-muted">{{ button_html_add_sequence }}</small>
                  <p class="mb-0"> {{ node.data.sequenceIdText }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.sequenceIdValueRemove && node.data.sequenceIdTextRemove">   
                  <small class="text-muted">{{ button_html_remove_sequence }}</small>
                  <p class="mb-0"> {{ node.data.sequenceIdTextRemove }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationGroupId && node.data.conversationGroupText">   
                  <small class="text-muted">{{ button_html_conversation_group }}</small>
                  <p class="mb-0"> {{ node.data.conversationGroupText }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.conversationUserId && node.data.conversationUserText">   
                  <small class="text-muted">{{ button_html_conversation_user }}</small>
                  <p class="mb-0"> {{ node.data.conversationUserText }}</p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.buttonWebhookUrl && node.data.buttonWebhookUrl">   
                  <small class="text-muted"><a>{{ button_html_label_webhook_url }}</a></small>
                  <p class="mb-0">
                    <a :href="node.data.buttonWebhookUrl" :title="node.data.buttonWebhookUrl" target="_BLANK">{{node.data.buttonWebhookUrl.length>40 ? node.data.buttonWebhookUrl.slice(0, 40)+'...' : node.data.buttonWebhookUrl}}</a>
                  </p>
                </span>
                <span href="#" class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="getSelectedGoogleSheets(node)">
                  <small class="text-muted">{{ button_html_google_sheet_add }}</small>
                  <p class="mb-0"> {{ getSelectedGoogleSheets(node) }}</p>
                </span>
              </div>
  
            </div>
            <div v-else>            
              <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.replyTypeText ">
            </div>
          </div>
          <div v-else class="double-click-div text-center">
            <img :src="icon_doubletap" :title="double_click_for_settings">
          </div>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :ref="output.key === quickReplyOutputSequenceSocet ? 'quickReplyOutputSequence' : ''" :class="[toggleSpecificSocket(node), hasConnection(output) ? 'has-connection' : '']">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import CONST_SOCKET from '../../const/socket'
import { lang } from '../../assets/lang'
import { templateComponentMethods, updateNodeConnections } from '../../utils/functions'

export default {
  name: 'QuickReplyTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    otn_single_html_labels: lang.otn_single_html_labels,
    otn_single_template_sequence_name: lang.otn_single_template_sequence_name,
    button_html_add_label: lang.button_html_add_label,
    button_html_remove_label: lang.button_html_remove_label,
    button_html_add_sequence: lang.button_html_add_sequence,
    button_html_remove_sequence: lang.button_html_remove_sequence,
    button_html_conversation_group: lang.button_html_conversation_group,
    button_html_conversation_user: lang.button_html_conversation_user,
    button_html_label_webhook_url: lang.button_html_label_webhook_url,
    button_html_label_action_type: lang.button_html_label_action_type,
    button_html_label_web_url: lang.button_html_label_web_url,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
    quickReplyOutputSequenceSocet: CONST_SOCKET.QUICK_REPLY_OUTPUT_SEQUENCE,
    button_html_google_sheet_add: button_html_google_sheet_add,
  }),

  methods: {
    ...templateComponentMethods,

    isSequenceSocketHidable(node, output) {
      return !! node.quickReplyNodeSequenceSocketStatus && (output.key === CONST_SOCKET.QUICK_REPLY_OUTPUT_SEQUENCE)
    },

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    },
    getSelectedRemoveLabelTexts(node) {
      const labelIdTextsArrayRemove = node.data.labelIdTextsArrayRemove || []
      return labelIdTextsArrayRemove.join(', ')
    },
    getSelectedGoogleSheets(node) {
      const googleSheetsArray = node.data.googleSheetsArray || []
      return googleSheetsArray.join(', ')
    },

    toggleSpecificSocket(node) {
      const that = this
      if(this.$refs.quickReplyOutputSequence) {
        const element = that.$refs.quickReplyOutputSequence[0]
        if('newSequence' === node.data.sequenceIdValue) {
          element.classList.remove('d-none')
          element.classList.add('d-block')
        } else {
          element.classList.remove('d-block')
          element.classList.add('d-none')
          setTimeout(function() {
            element.classList.remove('d-block')
            element.classList.add('d-none')
          }, 100)
        }
      }
    },

  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>